<template>
  <div class="mgx_pressed" v-if="monitorJourney">
    <div class="mgx_pressed_depth">
      <progress class="mgx_pressed_value" :max="getMaxTravel()" :value="travel"></progress>
    </div>
  </div>
  <img v-else class="img" src="../../assets/img/pressed.png" />
</template>
<script lang="ts" setup>
import { travelConfig } from '@/define/magnet_travel'
import { PropType } from 'vue'
import { DeviceManager } from '@/service/device'
import { speciaBehiver, specialCheckCurrent } from '@/define/limit'

const getMaxTravel = () => {
  let max = travelConfig(DeviceManager.instance.state.currentPid).maxTravel
  if (specialCheckCurrent(speciaBehiver.DeviceTravelAbove6800)) {
    return (max *= 2)
  }
  return max
}

defineProps({
  travel: {
    type: Number as PropType<number>,
    required: true,
  },
  // 是否监控行程
  monitorJourney: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
})
</script>
<style lang="less" scoped>
.mgx_pressed {
  width: 260px;
  height: 260px;
  background: var(--glass-ghost-bg);
  backdrop-filter: var(--glass-ghost-blur);
  border: 1px solid var(--glass-ghost-border);
  border-radius: var(--radius-l);
  margin-left: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition-base);
}

.mgx_pressed_depth {
  width: 180px;
  height: 228px;
  background: url(../../assets/img/pressed_depth_bg.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .mgx_pressed_value {
    transform: rotate(90deg);
    height: 38px;
    width: 127px;
    margin-top: 36px;

    &::-webkit-progress-bar {
      background: rgba(255, 255, 255, 0.05);
    }

    &::-webkit-progress-value {
      background: var(--color-white);
      box-shadow: 0 0 15px var(--brand-color-pure);
    }
  }
}

.img {
  width: 130px;
  height: 184px;
  margin-bottom: 16px;
}
</style>
